module.exports = __webpack_public_path__ + "img/SKMJ_light1.dd768474.jpg";